export default __webpack_public_path__ + "static/media/Large-Bread.6b2460c3.jpg";